import Toast from './Toast';
import { useToastStore } from '../../store/toastStore';
import { useSettingsStore, DEFAULT_TOAST_POSITION, type ToastPosition } from '../../store/settingsStore';

const POSITION_CLASSES: Record<ToastPosition, string> = {
  'top-right': 'right-4 top-4 items-end',
  'top-left': 'left-4 top-4 items-start',
  'bottom-left': 'left-4 bottom-4 items-start',
  'bottom-right': 'right-4 bottom-4 items-end',
  'center-right': 'right-4 top-1/2 -translate-y-1/2 items-end',
  'center-left': 'left-4 top-1/2 -translate-y-1/2 items-start',
  'top-center': 'top-4 left-1/2 -translate-x-1/2 items-center',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2 items-center',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToastStore();
  const toastPosition = useSettingsStore((s) => s.toastPosition) || DEFAULT_TOAST_POSITION;
  const classes = POSITION_CLASSES[toastPosition] || POSITION_CLASSES[DEFAULT_TOAST_POSITION];
  return (
    <div className={`pointer-events-none fixed z-[120] flex w-max max-w-[calc(100vw-2rem)] flex-col gap-2 ${classes}`}>
      <div className="pointer-events-auto flex flex-col gap-2">
        {toasts.map((toast) => <Toast key={toast.id} message={toast.message} type={toast.type} onClose={() => removeToast(toast.id)} />)}
      </div>
    </div>
  );
}
